import common from "./common";
import SplashScene from "./scenes/SplashScene";
import CharacterRequestScene from "./scenes/CharacterRequestScene";
import HelpScene from "./scenes/HelpScene";
import Stage_Cutting from "./Stages/Stage_Cutting";
import Stage_Photo from "./Stages/Stage_Photo";
import Stage_Oven from "./Stages/Stage_Oven";
import Stage_Decoration from './Stages/Stage_Decoration';
import Stage_Ingredients from "./Stages/Stage_Ingredients";

export default class Application {
    constructor() {}

    init() {
        this.showSplashScene();
        //this.showCharacterRequestScene();
    }

    changeScene(index) {
        let scene = null;

        switch (common.selectedRecipeBuild.stages[index]) {
            case 1:
                common.doughColour= null;
                common.doughIngredient= null;
                common.cutCookieTextures= null;
                common.finishedRecipe= null;
                scene = new Stage_Ingredients();
                break;
            case 2:
                scene = new Stage_Cutting();
                break;
            case 3:
                scene = new Stage_Oven();
                break;
            case 4:
                scene = new Stage_Decoration();
            break;
            case 5:
                scene = new Stage_Photo();
        }
        if (scene === null) {
            this.showSplashScene();
        } else {
            scene.autoAppear = false;

            scene.signals.next.add(function () {
                this.changeScene(index + 1);
            }, this);
            scene.signals.help.add(function () {
                scene.pauseGame();
                this.showHelpScene(scene);
            }, this);
            scene.signals.reload.add(function () {
                this.changeScene(index);
            }, this);


            this.fadeTransition(function () {
                P3.scene.show(scene);
            }, function () {
                scene.appear();
                //TEST: add check for first time user... show help screen
                if(window.localStorage.getItem("firstTime") === null){
                    this.showHelpScene(scene);
                    window.localStorage.setItem("firstTime", true);
                }
            }, this);
            return scene;
        }
    }

    showSplashScene() {
        const scene = new SplashScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showCharacterRequestScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        P3.audio.playMusic("music_ambient_music_loop_00");
        return scene;
    }

    showCharacterRequestScene() {
        const scene = new CharacterRequestScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.changeScene(0);
        }, this);
        scene.signals.previous.add(function () {
            this.showSplashScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        P3.audio.playMusic("music_ambient_music_loop_00");
        return scene;
    }

    showHelpScene(previousScene) {
        const scene = new HelpScene();

        // scene.signals.previous.add(function () {
        //     P3.scene.remove();
        //     previousScene.resumeGame();
        // }, this);
        // scene.signals.next.add(function () {
        //     this.showSplashScene();
        // }, this);
       // P3.scene.add(scene);

        //console.log("help scene");
        //return scene;
    }

    fadeTransition(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition(0x0);
        common.transitions.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);
        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);
        transition.in();
    }
}